<template>
    <div class="loading-overlay">
      <div class="spinner">
        <div
          v-for="n in 10"
          :key="n"
          class="spinner-dot"
          :style="dotStyle(n)"
        ></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LoadingSpinner",
    methods: {
      dotStyle(n) {
        const angle = (360 / 10) * n;
        return {
          transform: `rotate(${-angle}deg) translate(0, -40px)`,
          animationDelay: `-${n * 0.1}s`,
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(255,255,255,0.9); */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  .spinner {
    position: relative;
    width: 100px;
    height: 100px;
  }
  .spinner-dot {
    width: 12px;
    height: 12px;
    background-color: gray;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -6px 0 0 -6px;
    animation: spinner 1s linear infinite;
  }
  @keyframes spinner {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }
  </style>